// extracted by mini-css-extract-plugin
export var hidden = "_tc-0";